import { Api } from '@shared/api';

import type { DirectusDto, ShopApiDto } from '@do/data-transfer-objects';

import type { ArtAsset } from '@entities/art-asset';
import type { ArtAssetReadManyResponse, ArtAssetsReadManyArguments } from '../types';

export class ArtAssetCardApi extends Api {
  public async readOne(id: string | number): Promise<ArtAsset> {
    const res = await this.fetch(`${this.baseUrl}/art-assets/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return res.json();
  }

  public async readManySimilar(id: string | number): Promise<ShopApiDto.ReadManySimilarArtAssetsResponse> {
    const res = await this.fetch(`${this.baseUrl}/art-assets/${id}/similar?limit=4&offset=0`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return res.json();
  }

  public async readMany({
    page,
    loadMore,
    institutionId,
    perPage,
    order,
    offset,
    sort,
    artists,
    medium,
    styles,
  }: ArtAssetsReadManyArguments): Promise<ArtAssetReadManyResponse> {
    const perPageMultiplier: number = loadMore ? +loadMore + 1 : 1;

    const artAssetQuery = new URLSearchParams();
    artAssetQuery.append('offset', `${offset || (page - 1) * perPage}`);
    artAssetQuery.append('limit', `${perPage * perPageMultiplier}`);
    artAssetQuery.append('institutions', institutionId.toString());
    if (sort) artAssetQuery.append('column', `${sort}`);
    if (order) artAssetQuery.append('order', `${order}`);
    if (artists) artAssetQuery.append('artists', artists);
    if (medium) artAssetQuery.append('medium', medium);
    if (styles) artAssetQuery.append('styles', styles);

    const response = await this.fetch(`${this.baseUrl}/art-assets?${artAssetQuery}`).then((resp) => resp.json());

    return {
      artworks: response.art_assets,
      totalCount: response.total_count,
    };
  }
  public async readTotalCount(institutionId: number): Promise<number> {
    const artAssetQuery = new URLSearchParams();

    artAssetQuery.append('institutions', institutionId.toString());

    const response = await this.fetch(`${this.baseUrl}/art-assets/total-count?${artAssetQuery}`).then((resp) =>
      resp.json(),
    );

    return response;
  }
  public async readTilesData(id: string): Promise<DirectusDto.TileDto[]> {
    const response = await this.fetch(`${this.baseUrl}/tiles/${id}`);

    if (!response.ok) {
      return [];
    } else {
      return response.json();
    }
  }
}
